import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AutofillDropdownService {
  dropdownStatus: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  /** current display status of the autocomplete dropdown */
  private _active = false;

  get active(): boolean {
    return this._active;
  }

  set active(b: boolean) {
    this._active = b;
    this.dropdownStatus.next(b);
  }

  show(): void {
    this.active = true;
  }

  hide(): void {
    this.active = false;
  }
}
